import React from "react";
import WagerTypes from "../constants/WagerTypes";
import EntriesTable from "./EntriesTable";

const Exacta = ({
  raceInfo,
  entriesInfo,
  idExacta,
  idBox,
  addToCart,
  disabledAll,
  checkBoxState,
}) => {
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="Exacta"
        role="tabpanel"
        aria-labelledby="Exacta"
      >
        <EntriesTable
          raceInfo={raceInfo}
          entriesInfo={entriesInfo}
          wt={WagerTypes.EXACTA.name}
          idWT={idExacta}
          idBox={idBox}
          addToCart={addToCart}
          disabledAll={disabledAll}
          checkBoxState={checkBoxState}
        />
      </div>
    </>
  );
};

export default Exacta;
